import React, { useState,useEffect } from "react";
// import { ChevronLeft, ChevronRight } from "lucide-react";
import { FaPhoneAlt, FaArrowRight, FaEnvelopeOpenText,FaHeadset } from "react-icons/fa";
import AOS from "aos";
 import { FaUserTie, FaClipboardCheck,FaChartBar,FaUsers,FaCreditCard, FaLock, FaGift, FaBolt, FaShieldAlt} from 'react-icons/fa';
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Grid, Box, Typography } from '@mui/material';
import { Link as LinkIcon } from '@mui/icons-material';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { keyframes } from '@emotion/react';
import "aos/dist/aos.css";
import {
  Check,
  Wallet,
  Building2,
  User,
  BarChart2,
  Lock,
  Smartphone,
  Award,
  FileText,
  Ban,
  CheckCheck,
  PartyPopper,
  Store,
  ClipboardList,
  SearchCheck,
  AlertTriangle,
  CreditCard,
  Send,
  ShieldCheck,
  BriefcaseBusiness,
  Headset,
} from "lucide-react";

 
const CitizenWallet = () => {
   const [activeTab, setActiveTab] = useState("employee");
   
   const navigate = useNavigate();
   const employeeBenefits = [
     {
       icon: <FaCreditCard size={26} />,
       bg: "linear-gradient(135deg, #6366f1, #8b5cf6)", // Purple-blue
       title: "One Card",
       desc: "A single card for all employee benefits and seamless spending."
     },
     {
       icon: <FaLock size={26} />,
       bg: "linear-gradient(135deg, #10b981, #34d399)", // Green
       title: "Work Assistance",
       desc: "24/7 access to make requests and manage benefits online easily."
     },
     {
       icon: <FaBolt size={26} />,
       bg: "linear-gradient(135deg, #f97316, #f59e0b)", // Orange-yellow
       title: "Instant Approval",
       desc: "Get fast approvals with a smart system built for growing teams."
     },
     {
       icon: <FaGift size={26} />,
       bg: "linear-gradient(135deg, #ec4899, #f472b6)", // Pink
       title: "No Capex",
       desc: "Zero upfront investment with free employee card issuance."
     },
     {
       icon: <FaShieldAlt size={26} />,
       bg: "linear-gradient(135deg, #10b981, #34d399)", // Green
       title: "100% Secure",
       desc: "Bank-grade security protecting all transactions and data."
     },
     {
       icon: <FaUsers size={26} />,
       bg: "linear-gradient(135deg, #6366f1, #60a5fa)", // Indigo-blue
       title: "Happy Employees",
       desc: "Delight your team with a smooth and flexible payment experience."
     }
   ];
   
   const hrBenefits = [
     {
       icon: <FaUserTie size={26} />,
       bg: "linear-gradient(135deg, #8b5cf6, #6366f1)", // Purple
       title: "Central Control",
       desc: "Manage all employee cards and expenses from one easy dashboard."
     },
     {
       icon: <FaClipboardCheck size={26} />,
       bg: "linear-gradient(135deg, #f59e0b, #f97316)", // Orange-yellow
       title: "Compliance Ready",
       desc: "Keep audits stress-free with detailed logs and secure workflows."
     },
     {
       icon: <FaChartBar size={26} />,
       bg: "linear-gradient(135deg, #60a5fa, #3b82f6)", // Blue
       title: "Reports & Insights",
       desc: "Analyze spending trends and optimize budgets with smart insights."
     },
     {
       icon: <FaGift size={26} />,
       bg: "linear-gradient(135deg, #ec4899, #f472b6)", // Pink
       title: "Zero Capex",
       desc: "Setup at zero cost with no hardware or licensing investment."
     },
     {
       icon: <FaShieldAlt size={26} />,
       bg: "linear-gradient(135deg, #10b981, #34d399)", // Green
       title: "Advanced Security",
       desc: "Enterprise-grade protection with PIN sync and encryption."
     },
     {
       icon: <FaUsers size={26} />,
       bg: "linear-gradient(135deg, #6366f1, #60a5fa)", // Indigo-blue
       title: "Better Engagement",
       desc: "Boost employee morale with hassle-free reimbursements and perks."
     }
   ];
   const benefits = activeTab === "employee" ? employeeBenefits : hrBenefits;
  const [currentPage, setCurrentPage] = useState(0);
 useEffect(() => {
  AOS.init({ duration: 1000 });
}, []);
  const partnerSlides = [
    { icon: "🏛️", label: "Telangana State" },
    { icon: "IN", label: "Digital India" },
    { icon: "💳", label: "UPI Integration" },
    { icon: "🏦", label: "NPCI" },
    { icon: "🧾", label: "GST Portal" },
    { icon: "📱", label: "Mobile Seva" },
  ];

const openTwallet = () => {
  window.open("https://twallet.telangana.gov.in/");
};

const openEwallet = () => {
  window.open("https://ewallet.rajasthan.gov.in/", "_blank");
};

const openTAWallet = () => {
  window.open("https://tawalletapi.azurewebsites.net/", "_blank");
};
 
  const slidesPerPage = 3;
  const totalPages = Math.ceil(partnerSlides.length / slidesPerPage);
 


// Dot animations
const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
`;

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

const hoverEffect = {
  transform: 'scale(1.05)',
  transition: 'transform 0.3s ease',
};

const features = [
  {
    icon: "🕒",
    title: "24x7 Availability",
    description:
      "Transfer money anytime, anywhere – even on holidays and weekends. UPI never sleeps.",
    color: "#0037CC",
  },
  {
    icon: "🛡️",
    title: "Bank-Grade Security",
    description:
      "Multi-layer security with UPI PIN, device binding, and encrypted transactions for complete peace of mind.",
    color: "#00A04E",
  },
  {
    icon: "⚡",
    title: "Instant Transfers",
    description:
      "Money reaches the recipient's account within seconds. No waiting, no delays.",
    color: "#FFB800",
  },
  {
    icon: "🏦",
    title: "Direct Bank Transfer",
    description:
      "Money moves directly between bank accounts with no need for intermediaries.",
    color: "#0037CC",
  },
  {
    icon: "🔳",
    title: "QR Code Payments",
    description:
      "Simply scan and pay. Perfect for merchants, service providers, and P2P transfers.",
    color: "#00A04E",
  },
  {
    icon: "💸",
    title: "Low or No Fees",
    description:
      "Most UPI transactions are free or have negligible charges, making it cost-effective.",
    color: "#FFB800",
  },
];

 const steps = [
   {
    id: '01',
    title: 'Download TA One App',
    description:
      "Enjoy fast and secure UPI payments with the TA One app — your all-in-one wallet.",
    points: [
      'Available on Android & iOS',
      'Free to download',
      'Multiple options available',
    ],
    icon: <SmartphoneIcon sx={{ fontSize: 60, color: '#fff' }} />,
    iconBg: 'linear-gradient(180deg, #0052D4 0%, #2E8BFF 100%)',
    iconColor: '#0052D4',
  },
  {
    id: '02',
    title: 'Link Your Bank Account',
    description:
      'Connect your bank account securely within the app. Your bank details are encrypted and protected.',
    points: [
      'Bank-grade encryption',
      'Multiple account support',
      'Instant verification',
    ],
    icon: <LinkIcon sx={{ fontSize: 60, color: '#fff' }} />,
    iconBg: 'linear-gradient(180deg, #00B464 0%, #22D07A 100%)',
    iconColor: '#00B464',
  },
  {
    id: '03',
    title: 'Create UPI PIN',
    description:
      'Set up your unique UPI PIN for secure transactions. This PIN ensures only you can authorize payments.',
    points: [
      '4 or 6 digit PIN',
      'Secure authentication',
      'Easy to remember',
    ],
    icon: <CreditCardIcon sx={{ fontSize: 60, color: '#fff' }} />,
    iconBg: 'linear-gradient(180deg, #0052D4 0%, #2E8BFF 100%)',
    iconColor: '#0052D4',
  },
  {
    id: '04',
    title: 'Start Transacting',
    description:
      "You're all set! Start sending money, paying bills, and making purchases with just a few taps.",
    points: [
      'Instant payments',
      '24x7 availability',
      'Multiple payment methods',
    ],
    icon: <CheckCircleIcon sx={{ fontSize: 60, color: '#fff' }} />,
    iconBg: 'linear-gradient(180deg, #00B464 0%, #22D07A 100%)',
    iconColor: '#00B464',
  },
];
const Role = ({ icon, label, bg, color }) => (
  <div
    style={{
      textAlign: "center",
      fontSize: "0.85rem", 
      fontWeight: 500,
    }}
  >
    <div
      style={{
        background: bg,
        color: color,
        width: "50px",
        height: "50px",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "1.2rem",
        marginBottom: "0.3rem",
        transition: "transform 0.3s",
      }}
    >
      {icon}
    </div>
    <div>{label}</div>
  </div>
);

 const sectionStyle = {
    paddingTop: "4rem",
    // background: "linear-gradient(to bottom, #fdf2f8, #f0f9ff)",
    fontFamily: "'Inter', sans-serif",
  };

  const badgeStyle = {
    display: "inline-block",
    background: "linear-gradient(90deg, #9333ea, #3b82f6)",
    color: "white",
    padding: "0.4rem 1rem",
    borderRadius: "999px",
    fontWeight: 600,
    marginBottom: "1rem",
    fontSize: "0.9rem",
  };

  const titleStyle = {
    fontSize: "40px",
    fontWeight: 800,
    color: "#354237ff",
    marginBottom: "0.4rem",
    textAlign: "center",
  };

  const subtitleStyle = {
    color: "#6b7280",
    textAlign: "center",
    fontSize: "18px",
    maxWidth: "700px",
    margin: "1rem auto 3rem auto",
    
  };

  const columnsContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "0rem",
  };

  const columnStyle = {
    flex: "1 1 380px",
    // background: "#fff",
    borderRadius: "1rem",
    padding: "2rem",
    // boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  };

  const columnHoverStyle = {
    transform: "translateY(-8px)",
    // boxShadow: "0 16px 40px rgba(0, 0, 0, 0.15)",
  };

  const tagWrapperStyle = {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    marginBottom: "1rem",
  };

  const dotStyle = (bgColor) => ({
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    background: bgColor,
  });

  const tagTextStyle = (color) => ({
    color: color,
    fontWeight: 800,
    fontSize:"20px"
  });

  const columnTitleStyle = {
    fontSize: "28px",
    fontWeight: 700,
    marginBottom: "0.4rem",
    color: "#111827",
  };

  const columnDescStyle = {
    fontSize: "18px",
    color: "#6b7280",
    marginBottom: "1.5rem",
  };

  const itemsContainerStyle = {
    display: "grid",
    gap: "1rem",
  };

  const cardStyle = {
    display: "flex",
    alignItems: "center",
    // background: "linear-gradient(to right, #f0fdf4, #f0f9ff)",
    padding: "1.5rem",
    borderRadius: "0.75rem",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.05)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    cursor: "pointer",
  };

  const cardHoverStyle = {
    transform: "translateY(-4px) scale(1.02)",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
  };

  const iconBoxStyle = {
    background: "#e0f2fe",
    color: "#2563eb",
    padding: "0.7rem",
    borderRadius: "0.6rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.2rem",
  };

  const textStyle = {
    marginLeft: "1rem",
    flex: 1,
    textAlign: "left",
  };

  const textTitleStyle = {
    fontSize: "18px",
    color: "#111827",
    fontWeight: 600,
    marginBottom: "0.2rem",
  };

  const textSubtitleStyle = {
    fontSize: "16px",
    color: "#6b7280",
  };

  const checkIconStyle = {
    color: "#10b981",
    fontSize: "1rem",
  };

  const govBenefits = [
    {
      icon: <Building2 size={18} />,
      title: "Digital Governance",
      subtitle: "Streamlined government service delivery",
    },
    {
      icon: <BarChart2 size={18} />,
      title: "Real-time Analytics",
      subtitle: "Track transactions and usage patterns",
    },
    {
      icon: <Wallet size={18} />,
      title: "Reduced Costs",
      subtitle: "Lower cash handling and processing fees",
    },
    {
      icon: <Lock size={18} />,
      title: "Secure Transactions",
      subtitle: "End-to-end encryption and fraud protection",
    },
    {
      icon: <BriefcaseBusiness size={18} />,
      title: "Financial Inclusion",
      subtitle: "Bring unbanked citizens into formal economy",
    },
    {
      icon: <Send size={18} />,
      title: "Instant Disbursals",
      subtitle: "Direct benefit transfers in real-time",
    },
  ];

  const citizenBenefits = [
    {
      icon: <Smartphone size={18} />,
      title: "Easy Mobile Access",
      subtitle: "Simple app interface for all age groups",
    },
    {
      icon: <Ban size={18} />,
      title: "Zero Transaction Fees",
      subtitle: "No charges for government transactions",
    },
    {
      icon: <Award size={18} />,
      title: "Cashback Rewards",
      subtitle: "Earn rewards on merchant payments",
    },
    {
      icon: <CreditCard size={18} />,
      title: "Quick Transfers",
      subtitle: "Instant money transfers to family & friends",
    },
    {
      icon: <FileText size={18} />,
      title: "Scheme Access",
      subtitle: "Direct access to government welfare schemes",
    },
    {
      icon: <ShieldCheck size={18} />,
      title: "Safe & Secure",
      subtitle: "Bank-level security for your money",
    },
  ];
 const citizenSteps = [
    ["Eligibility Check", "Verify identity & eligibility", <User size={30} color="#6b7280" />],
    ["Download App", "Install from Play Store/App Store", <Smartphone size={30} color="#6b7280" />],
    ["Document Upload", "Submit Aadhaar & basic details", <FileText size={30} color="#6b7280" />],
    ["Verification", "OTP & biometric verification", <CheckCheck size={30} color="#10b981" />],
    ["Wallet Active", "Start using your digital wallet", <PartyPopper size={30} color="#f59e0b" />],
  ];

  const businessSteps = [
    ["Business Registration", "Register your business details", <Store size={30} color="#6b7280" />],
    ["Document Verification", "Submit business licenses & PAN", <ClipboardList size={30} color="#6b7280" />],
    ["Payment Setup", "Configure payment methods", <CreditCard size={30} color="#6b7280" />],
    ["Review Process", "Platform verification (24–48 hrs)", <SearchCheck size={30} color="#f97316" />],
    ["Compliance Check", "Final regulatory approval", <AlertTriangle size={30} color="#dc2626" />],
  ];
const stepCardStyle = {
  background: "#fff",
  borderRadius: "0.8rem",
  padding: "1.5rem",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.08)", // Deeper shadow for depth
  position: "relative",
  marginBottom: "1rem",
  transition: "transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s cubic-bezier(0.4, 0, 0.2, 1)", // Smooth easing
  cursor: "pointer",
  width: "100%",
  maxWidth: "550px",
};


  const connectorStyle = {
    width: "2px",
    height: "30px",
    background: "#d1d5db",
    marginBottom:"10px",
  };
  return (
    <div >
<div
  className="launch-container"
  style={{
        background: "linear-gradient(135deg, #e5fce9ff, #ecfdf5)",
    paddingBottom: "10px",
    paddingTop: "20px",
  }}
>
  <section
    className="container"
    style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      // paddingTop: "20px",
      background: "linear-gradient(135deg, #e5fce9ff, #ecfdf5)",
      gap: "4rem",
      // fontFamily: "'Inter', sans-serif",
      flexWrap: "wrap",
    }}
  >
    {/* Left Content */}
    <div
      style={{ flex: 1, minWidth: "600px", maxWidth: "800px" }}
      data-aos="fade-right"
    >
      <h1
        style={{
          fontSize: "40px",
          fontWeight: "800",
          lineHeight: "1.2",
          // margin: 0,
        }}
      >
        <span style={{ color: "#424943ff" }}>PPI Business Solutions </span>
        
        <span style={{ color: "#424943ff" }}><span
          style={{
            background: "linear-gradient(135deg, #3b82f6, #10b981)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            display: "inline-block",
            fontWeight: "800",
          }}
        >
          (Wallet Services)
        </span></span>
        <br />
       
      </h1>
      <p
        style={{
          fontSize: "18px",
          color: "#4b5563",
          maxWidth: "600px",
          marginTop: "1.5rem",
        }}
      >
        Join millions of citizens accessing government benefits, making secure
        payments, and building financial independence through our trusted
        digital wallet platform.
      </p>

      {/* Stats */}
      <div
        style={{
          display: "flex",
          gap: "2rem",
          marginTop: "3rem",
          flexWrap: "wrap",
        }}
      >
        {[
          { label: "Active Users", value: "4.5M+", color: "#10b981" },
          { label: "Transactions/Month", value: "10L", color: "#3b82f6" },
          // { label: "Uptime", value: "99.9%", color: "#8b5cf6" },
        ].map((stat, index) => (
          <div
            key={index}
            style={{
              background: "#fff",
              borderRadius: "1rem",
              padding: "0.5rem ",
              textAlign: "center",
              minWidth: "120px",
              boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
              border: "1px solid #e5e7eb",
              flex: "1 1 120px",
            }}
          >
            <h3
              style={{
                fontSize: "1.5rem",
                fontWeight: "800",
                color: stat.color,
              }}
            >
              {stat.value}
            </h3>
            <p style={{ fontSize: "0.85rem", color: "#6b7280" }}>
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </div>

    {/* Right Image */}
    <div
      style={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "300px",
        // marginTop: "2rem",
      }}
      data-aos="zoom-in-up"
    >
      <img
        src="/assets/images/walletimage.png"
        alt="Digital Payments Illustration"
        style={{
          width: "100%",
          maxWidth: "600px",
          marginLeft:"20px",
          paddingBottom: "70px",
        }}
      />
    </div>

    {/* Responsive Styling */}
    <style>{`
      @media (max-width: 768px) {
        .container h1 {
          font-size: 2.5rem !important;
        }
        .container p {
          font-size: 1.25rem !important;
          margin: 1rem auto;
        }
        .container img {
          max-width: 90%;
          margin: 1rem auto 0;
        }
      }

     /* Tablet Responsive */
@media (max-width: 992px) {
  .launch-container .container {
    flex-direction: column; /* stack text and image */
    text-align: center;
    gap: 2rem;
  }

  .launch-container .container > div {
    min-width: 100% !important; /* avoid overflow */
    max-width: 100% !important;
  }

  .launch-container img {
    margin: 0 auto !important;
    padding-bottom: 30px !important;
  }

  .launch-container h1 {
    font-size: 2.2rem !important;
    line-height: 1.3 !important;
  }

  .launch-container p {
    font-size: 1rem !important;
    margin: 1rem auto;
  }

  .launch-container .stats {
    justify-content: center;
  }
}

/* Mobile Responsive */
@media (max-width: 576px) {
  .launch-container .container {
    padding: 0 15px;
  }

  .launch-container h1 {
    font-size: 1.8rem !important;
  }

  .launch-container p {
    font-size: 0.95rem !important;
  }

  .launch-container .stats {
    flex-direction: column;
    gap: 1rem;
    align-items: center;
  }

  .launch-container img {
    max-width: 90% !important;
  }
}

    `}</style>
  </section>
</div>


 <section
  className="container"
  style={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "4rem",
    padding: "6rem 0px 0px 0px",
    fontFamily: "'Inter', sans-serif",
  }}
>
  {/* Left Section */}
  <div
    style={{
      flex: "1 1 400px",
      padding: "10px",
      minWidth: "300px",
    }}
  >
    {/* Title */}
    <h2
      style={{
        fontSize: "40px",
        fontWeight: "800",
        lineHeight: "1.2",
        marginBottom: "1.5rem",
      }}
    >
      <span style={{ color: "#282928ff" }}>T Wallet</span>{" "}
      <span
        style={{
          background: "linear-gradient(135deg, #3b82f6, #10b981)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Cashless Initiative
      </span>
    </h2>

    {/* Description */}
    <p
      style={{
        fontSize: "18px",
        color: "#374151",
        maxWidth: "600px",
        marginBottom: "2.5rem",
      }}
    >
     Transaction Analysts (TA) is a leading fintech solutions provider, specializing in digital payments, Aadhaar-based services, and secure authentication systems. With its RBI PPI license, TA develops and operates platforms like TA Wallet and also partners with governments and enterprises to deliver customized payment ecosystems (e.g., Jan Aadhaar eWallet for Government of Rajasthan). 
    </p>

    {/* Button */}
    <button
    onClick={openTwallet}
      style={{
        background: "#f97316",
        color: "#fff",
        padding: "0.8rem 2rem",
        borderRadius: "0.75rem",
        border: "none",
        fontWeight: "600",
        fontSize: "18px",
        cursor: "pointer",
        boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
      }}
    >
      Learn More About T Wallet
    </button>
  </div>

  {/* Right Section (Image only) */}
  <div
    style={{
      flex: "1 1 400px",
      minWidth: "300px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <img
      src="/assets/images/walletimg.png" // 👉 replace with your image path
      alt="T Wallet"
      style={{
        width: "70%",
        maxWidth: "500px",
        borderRadius: "1.5rem",
        height:"300px"
      }}
    />
  </div>
</section>


 <section
  className="container"
  style={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "4rem",
    padding: "6rem 0px 0px 0px",
    fontFamily: "'Inter', sans-serif",
  }}
>
    {/* Right Section (Image only) */}
  <div
    style={{
      flex: "1 1 400px",
      minWidth: "300px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <img
      src="assets/images/taoneimg.png" // 👉 replace with your image path
      alt="T Wallet"
      style={{
        width: "80%",
        maxWidth: "500px",
        borderRadius: "1.5rem",
        height:"350px"
      }}
    />
  </div>
  {/* Left Section */}
  <div
    style={{
      flex: "1 1 400px",
      padding: "10px",
      minWidth: "300px",
    }}
  >
    {/* Title */}
    <h2
      style={{
        fontSize: "40px",
        fontWeight: "800",
        lineHeight: "1.2",
        marginBottom: "1.5rem",
      }}
    >
      <span style={{ color: "#282928ff" }}>TA Wallet</span>{" "}
      <span
        style={{
          background: "linear-gradient(135deg, #3b82f6, #10b981)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        Cashless Initiative
      </span>
    </h2>

    {/* Description */}
    <p
      style={{
        fontSize: "18px",
        color: "#374151",
        maxWidth: "600px",
        marginBottom: "1.5rem",
      }}
    >
    TA Wallet is a next-generation digital payment wallet developed by Transaction Analysts (India) Pvt. Ltd., designed to provide citizens with a secure, fast, and convenient platform for managing everyday financial transactions. Built under strict RBI compliance and industry best practices, TA Wallet integrates multiple digital payment services into a single ecosystem.

    </p>
{/* <ul>
  <li>User-Friendly: Simple interface for all citizens, including rural and semi-urban users. </li>


<li>All-in-One Platform: Combines money transfer, utility payments, recharges, and UPI services in one app. </li>

<li>Trustworthy & Secure: Developed by an RBI-licensed company, ensuring regulatory compliance and highest data security.</li>

 <li>Scalable & Reliable: Capable of handling large transaction volumes for both individual and business use. </li>
</ul> */}
    {/* Button */}
    <button
     onClick={openTAWallet}
      style={{
        background: "#f97316",
        color: "#fff",
        padding: "0.8rem 2rem",
        borderRadius: "0.75rem",
        border: "none",
        fontWeight: "600",
        fontSize: "18px",
        cursor: "pointer",
        boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
      }}
    >
      Learn More About TA Wallet
    </button>
  </div>


</section>



 <section
  className="container"
  style={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "4rem",
    padding: "6rem 0px 0px 0px",
    fontFamily: "'Inter', sans-serif",
  }}
>
  {/* Left Section */}
  <div
    style={{
      flex: "1 1 400px",
      padding: "10px",
      minWidth: "300px",
    }}
  >
    {/* Title */}
    <h2
      style={{
        fontSize: "40px",
        fontWeight: "800",
        lineHeight: "1.2",
        marginBottom: "1.5rem",
      }}
    >
      <span style={{ color: "#282928ff" }}>Jan Aadhaar</span>{" "}
      <span
        style={{
          background: "linear-gradient(135deg, #3b82f6, #10b981)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
      eWallet
      </span>
    </h2>

    {/* Description */}
    <p
      style={{
        fontSize: "18px",
        color: "#374151",
        maxWidth: "600px",
        marginBottom: "2.5rem",
      }}
    >
      The Government of Rajasthan launched the Rajasthan Jan Aadhaar Yojana with the vision of “One Number, One Card, One Identity” to provide welfare benefits and government services to citizens in a simple, transparent, and convenient manner. 

The Jan Aadhaar eWallet is a secure, multilingual digital payment platform developed under the guidance of the Department of Information Technology (DoIT), Government of Rajasthan, powered in collaboration with Raj Infocom, and designed and implemented by Transaction Analysts (India) Pvt. Ltd., an RBI-licensed PPI provider.

    </p>

    <button
     onClick={openEwallet}
    
      style={{
        background: "#f97316",
        color: "#fff",
        padding: "0.8rem 2rem",
        borderRadius: "0.75rem",
        border: "none",
        fontWeight: "600",
        fontSize: "18px",
        cursor: "pointer",
        boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
      }}
    >
      Learn More About Jan Aadhaar
    </button>
  </div>

  {/* Right Section (Image only) */}
  <div
    style={{
      flex: "1 1 400px",
      minWidth: "300px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <img
      src="/assets/images/janadhaar.png" // 👉 replace with your image path
      alt="T Wallet"
      style={{
        width: "70%",
        maxWidth: "500px",
        borderRadius: "1.5rem",
        height:"250px"
      }}
    />
  </div>
</section>

    {/* Benefits Section */}
     <section  className="container" style={sectionStyle}>
      {/* <span style={badgeStyle} >🌟 Premium Benefits</span> */}
      <h2 style={titleStyle}>Benefits for Everyone</h2>
      <p style={subtitleStyle}>
        Our digital wallet creates value for both government institutions and
        citizens, fostering a transparent and efficient financial ecosystem.
      </p>

      <div style={columnsContainerStyle}> 
        {[{ title: "Efficient Governance", tag: "For Government", tagColor: "#065f46", dotColor: "#34d399", items: govBenefits },
          { title: "Financial Freedom", tag: "For Citizens", tagColor: "#1d4ed8", dotColor: "#60a5fa", items: citizenBenefits }]
          .map((col, idx) => (
            <div
              key={idx}
              style={columnStyle}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, columnHoverStyle)}
              onMouseLeave={(e) => Object.assign(e.currentTarget.style, columnStyle)}
            >
              <div style={tagWrapperStyle}>
                <span style={dotStyle(col.dotColor)}></span>
                <span style={tagTextStyle(col.tagColor)}>{col.tag}</span>
              </div>
              <h3 style={columnTitleStyle}>{col.title}</h3>
              <p style={columnDescStyle}>
                {idx === 0
                  ? "Streamline operations, reduce costs, and enhance service delivery with our digital infrastructure."
                  : "Experience seamless digital payments, exclusive rewards, and secure money management."}
              </p>
              <div style={itemsContainerStyle}>
                {col.items.map((item, index) => (
                  <div
                    key={index}
                    style={cardStyle}
                    onMouseEnter={(e) => Object.assign(e.currentTarget.style, cardHoverStyle)}
                    onMouseLeave={(e) => Object.assign(e.currentTarget.style, cardStyle)}
                  >
                    <div style={iconBoxStyle}>{item.icon}</div>
                    <div style={textStyle}>
                      <h4 style={textTitleStyle}>{item.title}</h4>
                      <p style={textSubtitleStyle}>{item.subtitle}</p>
                    </div>
                    <Check style={checkIconStyle} />
                  </div>
                ))}
              </div>
            </div>
          ))}
      </div>
    </section>
 
<section className="container"
      style={{
        background: "#f9fafb",
        paddingTop: "4rem",
        textAlign: "center",
        marginBottom:"30px",
        
        fontFamily: "Inter, sans-serif",
      }}
    >
      <h2
        style={{
          fontSize: "40px",
          fontWeight: "800",
          color: "#111827",
          marginBottom: "2rem",
        }}
      >
        Fast Digital <span
  style={{
    background: "linear-gradient(135deg, #3b82f6, #10b981)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    display: "inline-block",
  }}
>
  Onboarding
</span>

      </h2>
      <p
        style={{
          color: "#6b7280",
          fontSize: "18px",
          marginBottom: "2rem",
        }}
      >
        Get started in minutes with our streamlined onboarding process designed for <br />both customers and merchant partners.
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          gap: "1rem",
          marginBottom: "2.5rem",
          flexWrap: "wrap",
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.4rem",
            background: "#d1fae5",
            color: "#065f46",
            padding: "0.4rem 1rem",
            borderRadius: "9999px",
            fontWeight: "600",
         
            fontSize: "18px",
          }}
        >
          <User size={16} /> Customer Onboarding
        </span>
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.8rem",
            background: "#fef3c7",
            color: "#92400e",
            padding: "0.4rem 1rem",
            borderRadius: "9999px",
            
            fontWeight: "600",
            fontSize: "18px",
          }}
        >
          <BriefcaseBusiness size={16} /> Merchant Onboarding
        </span>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "1rem",
         
          flexWrap: "wrap",
        }}
      >
        {/* Citizens Column */}
        <div
          style={{
            flex: "1 1 420px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <h3
            style={{
              fontSize: "25px",
              fontWeight: "700",
              color: "#065f46",
              marginRight:"30px",
              marginBottom: "1rem",
            }}
          >
            Citizens & End Users
          </h3>
          <p
            style={{
              color: "#6b7280",
              fontSize: "18px",
              marginBottom: "1.5rem",
            }}
          >
            Simple 5-step process to activate your digital wallet
          </p>

          {citizenSteps.map(([title, subtitle, icon], index) => (
            <React.Fragment key={index}>
              <div
                style={stepCardStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.05)";
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
                  <span
                    style={{
                      background: "#206f3dff",
                      color: "#fff",
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Check size={14} />
                  </span>
                  <div style={{ textAlign: "left" }}>
                    <h4
                      style={{
                        margin: 0,
                        fontSize: "18px",
                        padding:'5px',
                        fontWeight: "600",
                        color: "#111827",
                      }}
                    >
                      {title}
                    </h4>
                    <p
                      style={{
                        margin: 0,
                        color: "#6b7280",
                        fontSize: "16px",
                      }}
                    >
                      {subtitle}
                    </p>
                  </div>
                </div>
                <div>{icon}</div>
              </div>
              {index < citizenSteps.length - 1 && <div style={connectorStyle}></div>}
            </React.Fragment>
          ))}
        </div>

        {/* Business Column */}
        <div
          style={{
            flex: "1 1 420px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <h3
            style={{
              fontSize: "25px",
              fontWeight: "700",
              color: "#92400e",
              marginBottom: "1rem",
              marginLeft:"30px"
            }}
          >
            Business Partners
          </h3>
          <p
            style={{
              color: "#6b7280",
              fontSize: "18px",
              marginBottom: "1.5rem",
            }}
          >
            Comprehensive verification for secure partnerships
          </p>

          {businessSteps.map(([title, subtitle, icon], index) => (
            <React.Fragment key={index}>
              <div
                style={stepCardStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow = "0 8px 20px rgba(0, 0, 0, 0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.05)";
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
                  <span
                    style={{
                      background: index < 3 ? "#206f3dff" : "#e94747ff",
                      color: "#fff",
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexShrink: 0,
                    }}
                  >
                    {index < 3 ? <Check size={14} /> : <AlertTriangle size={14} />}
                  </span>
                  <div style={{ textAlign: "left" }}>
                    <h4
                      style={{
                        margin: 0,
                        fontSize: "18px",
                        fontWeight: "600",
                         padding:'5px',
                        color: "#111827",
                      }}
                    >
                      {title}
                    </h4>
                    <p
                      style={{
                        margin: 0,
                        color: "#6b7280",
                        fontSize: "16px",
                      }}
                    >
                      {subtitle}
                    </p>
                  </div>
                </div>
                <div>{icon}</div>
              </div>
              {index < businessSteps.length - 1 && <div style={connectorStyle}></div>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>

    <div >
    <section className="section-card ">
  {/* Left Content */}
  <div className="section-content" data-aos="fade-right">
    <h1>TA PAYX</h1>
    <p className="subtitle">Reinventing Corporate Travel & Expense Management</p>
    <p className="description">
      Streamline your business expenses with our comprehensive platform.
      Automate travel bookings, manage reimbursements, and gain complete
      visibility into your corporate spending.
    </p>
    <button className="btn-primary" onClick={() => (window.location.href = "/")}>
      Get Started
    </button>
  </div>

  {/* Right-side Image */}
  <div className="section-image" data-aos="zoom-in-up">
    <img
      src="/assets/images/tapayximg.png"
      alt="Corporate Travel Illustration" 
    />
  </div>
</section>

</div>



<section className="wallet-features">
  <div className="container">
    <h2>
    All Employee Benefits in a Single Wallet Solution
    </h2>
    <p className="wallet-subtitle">
      We have a rapidly growing list of Use Cases from our clients
    </p>

    <div className="wallet-grid">
      {/* First Row */}
      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #f97316, #facc15)" }}>🍽️</div>
        <h3>Meal Vouchers</h3>
        <p>Digital meal voucher solutions for employees</p>
      </div>

      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #6366f1, #8b5cf6)" }}>📱</div>
        <h3>Telecom Reimbursements</h3>
        <p>Automated telecom expense management</p>
      </div>

      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #10b981, #34d399)" }}>⛽</div>
        <h3>Fuel Cards</h3>
        <p>Comprehensive fuel expense tracking</p>
      </div>

      {/* Second Row */}
      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #3b82f6, #60a5fa)" }}>🚗</div>
        <h3>Fleet Management</h3>
        <p>Complete vehicle fleet oversight</p>
      </div>

      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #ec4899, #f472b6)" }}>🎁</div>
        <h3>Employee Rewards</h3>
        <p>Recognition and reward programs</p>
      </div>

      <div className="wallet-card">
        <div className="wallet-icon" style={{ background: "linear-gradient(135deg, #06b6d4, #22d3ee)" }}>💳</div>
        <h3>Corporate Cards</h3>
        <p>Secure corporate card solutions</p>
      </div>
    </div>

    {/* Third Row */}
    <div className="wallet-mini-row">
      <div className="wallet-mini-card">
        <div className="wallet-mini-icon" style={{ background: "linear-gradient(135deg, #8b5cf6, #ec4899)" }}>📊</div>
        <p className="wallet-mini-text">Real-time Analytics</p>
      </div>
      <div className="wallet-mini-card">
        <div className="wallet-mini-icon" style={{ background: "linear-gradient(135deg, #10b981, #34d399)" }}>🔒</div>
        <p className="wallet-mini-text">Bank-level Security</p>
      </div>
      <div className="wallet-mini-card">
        <div className="wallet-mini-icon" style={{ background: "linear-gradient(135deg, #3b82f6, #60a5fa)" }}>📱</div>
        <p className="wallet-mini-text">Mobile First</p>
      </div>
      <div className="wallet-mini-card">
        <div className="wallet-mini-icon" style={{ background: "linear-gradient(135deg, #f59e0b, #fbbf24)" }}>⚡</div>
        <p className="wallet-mini-text">Instant Processing</p>
      </div>
    </div>
  </div>
</section>



<section className="benefits-section">
      <h3 ><b>Benefits at a Glance</b></h3>

      <div className="toggle-buttons">
        <button
          className={`tab-btn ${activeTab === "employee" ? "active" : ""}`}
          onClick={() => setActiveTab("employee")}
        >
          For Employees
        </button>
        <button
          className={`tab-btn ${activeTab === "hr" ? "active" : ""}`}
          onClick={() => setActiveTab("hr")}
        >
          For HR
        </button>
      </div>

      <div className="benefits-grid">
        {benefits.map((item, index) => (
          <div className="benefits-card" key={index}>
            <div className="icon" style={{ background: item.bg }}>
              {item.icon}
            </div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="cta-banner">
        <h4><b>Ready to Transform Your Employee Benefits?</b></h4>
        <p>
          Join thousands of companies who have already revolutionized their
          employee experience with our comprehensive platform.
        </p>
        <button className="cta-button">Get Started Today</button>
      </div>
    </section>

 <div
      style={{
        background: "linear-gradient(135deg, #fcf8e5ff, #ecfdf5)",
        color: "Black",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "40px 20px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: "70vh",
          gap: "40px",
          flexWrap: "wrap",
        }}
      >
        {/* Left Section with animation */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          style={{ flex: "1 1 500px", minWidth: "280px" }}
        >
          <div style={{ opacity: 0.8, marginBottom: "10px", fontWeight: "500" }}>
            ⚡ Revolutionary UPI Payments
          </div>
          <h1
            style={{
              fontSize: "40px",
              margin: 0,
              lineHeight: "1.2",
            }}
          >
            <span style={{ fontWeight: 700 }}>UPI Payments</span>{" "}
            <span style={{ fontWeight: 700, opacity: 0.7, color: "green" }}>
              Revolutionized
            </span>
          </h1>
          <p style={{ marginTop: "20px", fontSize: "18px", opacity: 0.85 }}>
            Experience the future of digital transactions with Unified Payments Interface (UPI) – instant, secure, and available 24x7.
          </p>
          <p style={{ fontSize: "16px", opacity: 0.75 }}>
            Unlock seamless financial connectivity with zero transaction fees, lightning-fast transfers, and enterprise-grade security.
          </p>

          {/* Buttons */}
          <div style={{ marginTop: "30px", display: "flex", flexWrap: "wrap", gap: "16px" }}>
         <button
  onClick={() => navigate("/download")}
  style={{
    background: "#00B464",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "14px 24px",
    fontSize: "16px",
    fontWeight: 600,
    cursor: "pointer",
  }}
>
  Get Started Now →
</button>
          </div>
        </motion.div>

        {/* Right Section (Image) with animation */}
      {/* Right Section (Image) with zoom-in animation */}
<motion.div
  initial={{ scale: 0.8, opacity: 0 }}
  animate={{ scale: 1, opacity: 1 }}
  transition={{ duration: 0.8, ease: "easeOut" }}
  style={{
    flex: "1 1 400px",
    minWidth: "280px",
    position: "relative",
    textAlign: "center",
  }}
>
  <img
    src="/assets/images/upipaymentimg.png"
    alt="UPI App"
    style={{
      maxWidth: "120%",
      height: "400px",
      borderRadius: "20px",
    }}
  />
</motion.div>

      </div>
    </div>

   <section style={{ background: "#F9FAFB", padding: "80px 0" }}>
  <div
    style={{
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 20px",
      fontFamily: "'Segoe UI', sans-serif",
    }}
  >
    <h2
      style={{
        fontSize: "36px",
        fontWeight: 700,
        color: "#111827",
        textAlign: "center",
      }}
    >
      Why Choose UPI?
    </h2>
    <p
      style={{
        fontSize: "18px",
        color: "#6B7280",
        maxWidth: "800px",
        margin: "10px auto 50px",
        textAlign: "center",
      }}
    >
      UPI has revolutionized digital payments in India with its seamless,
      secure, and instant transaction capabilities. Here's what makes it
      special.
    </p>

    {/* Responsive Card Grid */}
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
        gap: "24px",
      }}
    >
      {features.map((feature, index) => (
        <div
          key={index}
          style={{
            background: "#fff",
            padding: "30px",
            borderRadius: "12px",
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            textAlign: "left",
            transform: "translateY(0)",
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            animation: "fadeInUp 0.6s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow = "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px";
          }}
        >
          <div style={{ fontSize: "28px", color: feature.color }}>
            {feature.icon}
          </div>
          <h3
            style={{
              fontSize: "20px",
              fontWeight: 600,
              marginTop: "10px",
              color: "#111827",
            }}
          >
            {feature.title}
          </h3>
          <p
            style={{
              fontSize: "16px",
              color: "#6B7280",
              marginTop: "6px",
            }}
          >
            {feature.description}
          </p>
        </div>
      ))}
    </div>
  </div>

  {/* Animation Keyframes */}
  <style>
    {`
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `}
  </style>
</section>

<section style={{ background: "#F9FAFB", padding: "20px 0" }}>
  <Box sx={{ maxWidth: '1200px', mx: 'auto', px: 2 }}>
    <Typography variant="h4" align="center" sx={{ fontWeight: 600, mb: 4 }}>
      How UPI Works
    </Typography>
    <p
      style={{
        fontSize: "18px",
        color: "#6B7280",
        maxWidth: "800px",
        margin: "10px auto 50px",
        textAlign: "center",
      }}
    >
      Getting started with UPI is simple and takes just a few minutes. Follow these easy steps to join millions of users making seamless digital payments.
    </p>

    {steps.map((step, index) => {
      const isEven = index % 2 === 1;
      return (
       <Box
  key={step.id}
  sx={{
    backgroundColor: '#fff',
    borderRadius: 4,
    boxShadow: '0 8px 24px rgba(0,0,0,0.06)',
    overflow: 'hidden',
    mb: 4,
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    '&:hover': {
      transform: 'translateY(-6px) scale(1.02)',
      boxShadow: '0 12px 30px rgba(0, 0, 0, 0.1)',
    },
  }}
>

          <Grid container direction={isEven ? 'row-reverse' : 'row'}>
            {/* Icon Side */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  backgroundColor: '#E9F2FF',
                  height: '100%',
                  p: 10,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                }}
              >
                <Box
                  sx={{
                    width: 140,
                    height: 140,
                    borderRadius: 4,
                    background: step.iconBg,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    position: 'relative',
                    animation: `${pulse} 2s ease-in-out infinite`,
                    '&:hover': hoverEffect,
                  }}
                >
                  {step.icon}

                  {/* Yellow dot */}
                  <Box
                    sx={{
                      width: 18,
                      height: 18,
                      backgroundColor: '#FFCB00',
                      borderRadius: '50%',
                      position: 'absolute',
                      top: -9,
                      right: -9,
                      animation: `${bounce} 1.8s ease-in-out infinite`,
                    }}
                  />

                  {/* Dark dot */}
                  <Box
                    sx={{
                      width: 18,
                      height: 18,
                      backgroundColor: '#002D62',
                      borderRadius: '50%',
                      position: 'absolute',
                      bottom: -7,
                      left: -7,
                      animation: `${bounce} 2.2s ease-in-out infinite`,
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Text Side */}
            <Grid item xs={12} md={6}>
              <Box sx={{ p: { xs: 3, md: 4 } }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Typography
                    sx={{
                      fontSize: '42px',
                      fontWeight: 700,
                      color: '#D2DBEE',
                      mr: 1,
                    }}
                  >
                    {step.id}
                  </Typography>
                  <Box
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: 2,
                      backgroundColor: step.iconColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {React.cloneElement(step.icon, {
                      sx: { fontSize: 24, color: '#fff' },
                    })}
                  </Box>
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                  {step.title}
                </Typography>
                <Typography sx={{ color: '#555', fontSize: '15px', mb: 2 }}>
                  {step.description}
                </Typography>

                <Box component="ul" sx={{ pl: 3, m: 0, color: '#2E7D32' }}>
                  {step.points.map((point, idx) => (
                    <Box
                      key={idx}
                      component="li"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        fontSize: '15px',
                        mb: 1,
                        color: '#2E7D32',
                      }}
                    >
                      <CheckCircleIcon sx={{ fontSize: 18, mr: 1 }} />
                      {point}
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      );
    })}
  </Box>
</section>

{/* <section className="terms-section">
  <style>{`
    .terms-section {
      padding: 40px 10px;
      background: #f8fafc;
    }

    .terms-container {
      max-width: 1200px;
      margin: 0 auto;
    }

    .terms-heading {
      font-size: 36px;
      font-weight: 700;
      margin-bottom: 30px;
      color: #111827;
      text-align: left;
    }

    .terms-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .terms-item {
      background: #ffffff;
      padding: 15px 20px;
      border-radius: 16px;
      text-decoration: none;
      color: #065f46;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
    }

    .terms-item:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
    }

    .terms-left {
      display: flex;
      align-items: center;
      gap: 14px;
      font-size: 18px;
      font-weight: 500;
    }

    .terms-icon {
      background: #d1fae5;
      color: #065f46;
      padding: 10px;
      border-radius: 10px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .terms-arrow {
      font-size: 24px;
      color: #065f46;
      font-weight: bold;
    }

    @media (max-width: 768px) {
      .terms-heading {
        font-size: 26px;
        text-align: center;
      }

      .terms-item {
        padding: 16px 18px;
      }

      .terms-left span {
        font-size: 15px;
      }
    }
  `}</style>

  <div className="terms-container">

    <h3 className="terms-heading">
        Policies & Agreements
    </h3>

    <div className="terms-list">

      <a href="/compliance-center/ppi-rules" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>PPI Rules</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>
 <a href="/compliance-center/ta-wallet-terms-conditionsi" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>TA Wallet Terms & Conditions – English</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>
      <a href="/compliance-center/terms-conditions-hindi" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>TA Wallet Terms & Conditions – Hindi</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/compliance-center/terms-conditions-kannada" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>TA Wallet Terms & Conditions – Kannada</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/compliance-center/tag-wallet-terms-conditions" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">📄</div>
          <span>TAG Wallet Terms & Conditions</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

    </div>

  </div>
</section> */}

<section className="ta-support-section">
      <div className="ta-support-container ">
        
        {/* Header Area */}
        <div className="ta-support-header">
          <span className="ta-support-badge">PPI Help Center</span>
          <h3><b>PPI Instrument Support</b></h3>
          <p className="ta-support-subtext">
          Need help with wallet loading, card management, or PPI compliance? 
            Our specialized team is available 24/7 for all instrument queries.
          </p>
        </div>

        {/* Support Cards Grid */}
        <div className="ta-support-grid">
          
          {/* Card 1: Phone (Click to Call) */}
          <div className="ta-support-card">
            <div className="ta-card-icon phone-icon">
              <FaPhoneAlt />
            </div>
            <div className="ta-card-content">
              <h3>Nodal Officer</h3>
              <p>+91 8919056119</p>
              <small>Wallet & card blocking</small>
            </div>
            <div className="ta-card-arrow">
              <FaArrowRight />
            </div>
          </div>

          {/* Card 2: Email (Click to Email) */}
          <div className="ta-support-card">
            <div className="ta-card-icon email-icon">
              <FaEnvelopeOpenText />
            </div>
            <div className="ta-card-content">
              <h3>Nodal Officer Email</h3>
              <p>kirankumar.p@taipl.in</p>
              <small>KYC & onboarding queries</small>
            </div>
            <div className="ta-card-arrow">
              <FaArrowRight />
            </div>
          </div>

          {/* Card 3: Ticket (Primary Action) */}
          <a href="https://udir.transactionanalysts.com/customergrievance" target="_blank" rel="noopener noreferrer" className="ta-support-card ta-card-primary">
            <div className="ta-card-icon ticket-icon">
              <FaHeadset />
            </div>
            <div className="ta-card-content">
              <h3>Raise PPI Ticket</h3>
              <p>Wallet Portal</p>
              <small>Track loading issues 24/7</small>
            </div>
            <div className="ta-card-arrow">
              <FaArrowRight />
            </div>
          </a>

        </div>
      </div>
    </section>
    
    </div>
  );
};
 
export default CitizenWallet;
 